// Coordinate transformation utilities for grid/pixel conversions

/**
 * @typedef {import('../types/jsdoc-types.js').GridPoint} GridPoint
 * @typedef {import('../types/jsdoc-types.js').Position} Position
 * @typedef {import('../types/jsdoc-types.js').Point} Point
 */

/**
 * Convert grid point to pixel coordinates
 * @param {GridPoint} gridPoint - Grid point (x, y)
 * @param {number} gridSize - Size of each grid cell in pixels
 * @returns {Point} Pixel coordinates
 */
export function gridPointToPixel(gridPoint, gridSize) {
  return {
    x: gridPoint.x * gridSize,
    y: gridPoint.y * gridSize,
  };
}

/**
 * Convert grid cell position to pixel coordinates (center of cell)
 * @param {Position} position - Grid cell (col, row)
 * @param {number} gridSize - Size of each grid cell in pixels
 * @returns {Point} Center of cell in pixel coordinates
 */
export function cellToPixelCenter(position, gridSize) {
  return {
    x: (position.col + 0.5) * gridSize,
    y: (position.row + 0.5) * gridSize,
  };
}
